import { User, IncomeSource, Transaction, Asset, Debt } from "../types";

export const demoUser: User = {
  id: "demo-user",
  name: "Demo User",
  email: "demo@runway.app",
  avatar: "D",
  age: 30,
  riskTolerance: "moderate",
  investmentGoals: ["Retirement", "Emergency Fund"],
  emergencyFundTarget: 15000,
  retirementAge: 65,
  targetSavingsRate: 20,
  preferredInvestmentTypes: ["Index Funds", "Real Estate"],
  createdAt: new Date().toISOString(),
};

export const demoIncomeSources: IncomeSource[] = [
  {
    id: "demo-income-1",
    userId: "demo-user",
    name: "Software Engineer Salary",
    category: "Salary",
    amount: 8500,
    frequency: "monthly",
    description: "Full-time software engineering position",
    isActive: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-income-2",
    userId: "demo-user",
    name: "Freelance Web Development",
    category: "Freelance",
    amount: 2000,
    frequency: "monthly",
    description: "Part-time freelance work",
    isActive: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-income-3",
    userId: "demo-user",
    name: "Investment Dividends",
    category: "Investment",
    amount: 500,
    frequency: "monthly",
    description: "Dividend income from investment portfolio",
    isActive: true,
    createdAt: new Date().toISOString(),
  },
];

export const demoTransactions: Transaction[] = [
  {
    id: "demo-transaction-1",
    userId: "demo-user",
    type: "expense",
    category: "Housing",
    amount: 2500,
    description: "Rent",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-2",
    userId: "demo-user",
    type: "expense",
    category: "Groceries",
    amount: 600,
    description: "Monthly groceries",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-3",
    userId: "demo-user",
    type: "expense",
    category: "Transportation",
    amount: 400,
    description: "Gas and public transit",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-4",
    userId: "demo-user",
    type: "expense",
    category: "Utilities",
    amount: 200,
    description: "Electricity, water, internet",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-5",
    userId: "demo-user",
    type: "expense",
    category: "Entertainment",
    amount: 300,
    description: "Dining out and entertainment",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-6",
    userId: "demo-user",
    type: "expense",
    category: "Insurance",
    amount: 150,
    description: "Health and car insurance",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-7",
    userId: "demo-user",
    type: "expense",
    category: "Subscriptions",
    amount: 50,
    description: "Netflix, Spotify, etc.",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-transaction-8",
    userId: "demo-user",
    type: "expense",
    category: "Personal",
    amount: 200,
    description: "Personal care and miscellaneous",
    date: new Date().toISOString().split("T")[0],
    createdAt: new Date().toISOString(),
  },
];

export const demoAssets: Asset[] = [
  {
    id: "demo-asset-1",
    userId: "demo-user",
    name: "Emergency Fund",
    type: "savings",
    balance: 15000,
    monthlyContribution: 500,
    interestRate: 4.5,
    isLiquid: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-asset-2",
    userId: "demo-user",
    name: "401(k) Retirement",
    type: "retirement",
    balance: 85000,
    monthlyContribution: 1200,
    interestRate: 7.2,
    isLiquid: false,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-asset-3",
    userId: "demo-user",
    name: "Investment Portfolio",
    type: "investment",
    balance: 25000,
    monthlyContribution: 800,
    interestRate: 8.5,
    isLiquid: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-asset-4",
    userId: "demo-user",
    name: "Checking Account",
    type: "checking",
    balance: 5000,
    monthlyContribution: 0,
    interestRate: 0.5,
    isLiquid: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-asset-5",
    userId: "demo-user",
    name: "Crypto Portfolio",
    type: "crypto",
    balance: 8000,
    monthlyContribution: 200,
    interestRate: 0,
    isLiquid: true,
    createdAt: new Date().toISOString(),
  },
];

export const demoDebts: Debt[] = [
  {
    id: "demo-debt-1",
    userId: "demo-user",
    name: "Student Loan",
    type: "student-loan",
    balance: 25000,
    monthlyPayment: 300,
    interestRate: 5.5,
    isActive: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: "demo-debt-2",
    userId: "demo-user",
    name: "Credit Card",
    type: "credit-card",
    balance: 3000,
    monthlyPayment: 150,
    interestRate: 18.99,
    isActive: true,
    createdAt: new Date().toISOString(),
  },
];

export const demoPartners: any[] = [];

export const getDemoData = () => ({
  users: [demoUser],
  currentUserId: "demo-user",
  incomeSources: demoIncomeSources,
  transactions: demoTransactions,
  assets: demoAssets,
  debts: demoDebts,
  partners: demoPartners,
});

export const isDemoMode = () => {
  return localStorage.getItem("runway-demo-mode") === "true";
};

export const setDemoMode = (enabled: boolean) => {
  if (enabled) {
    localStorage.setItem("runway-demo-mode", "true");
  } else {
    localStorage.removeItem("runway-demo-mode");
  }
}; 